import { render } from "./AvMetodosPago.vue?vue&type=template&id=06eb1d5e&scoped=true"
import script from "./AvMetodosPago.vue?vue&type=script&lang=js"
export * from "./AvMetodosPago.vue?vue&type=script&lang=js"

import "./AvMetodosPago.vue?vue&type=style&index=0&id=06eb1d5e&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06eb1d5e"]])

export default __exports__